module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAgUlEQVRYR2NkGGDAOMD2M4w6ADMEDMoaaB4tF7rgdqA6wKgijeH//5k0d8B/xjCGCx2rQfaMpoHREBgNgdEQwFISVjjQvCC60HEAZgeqA0DFMCNjPc0d8P9/IwO0OB5kIUBzr2NaMJoLRkNgNAQGWQgMijbhgLaKR0vC0RAYgBAAAHvzICFC+um3AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/header-menu.png
// module id = fsAQ
// module chunks = 17